import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { merge, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as MeetingAttendeesActions from '../+state/meeting-attendees/meeting-attendees.actions';
import { MeetingAttendeesPartialState } from '../+state/meeting-attendees/meeting-attendees.reducer';
import { getMeeting, getMeetingLoaded } from '../+state/meeting-attendees/meeting-attendees.selectors';
import { MeetingCheckInSteps } from '../meeting-check-in-steps';

@Component({
  selector: 'mstar-meeting-code-validation',
  templateUrl: './meeting-code-validation.component.html',
  styleUrls: ['./meeting-code-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeetingCodeValidationComponent implements OnDestroy {

  // == CONSTANTS ============================================

  meetingCodeTypes = {
    code: 'code',
    email: 'email'
  };

  // == STATE ================================================

  meetingCode = new FormControl(null, Validators.required);
  email = new FormControl(null, [Validators.required, Validators.email]);

  invalidMeetingMessage = new Subject<string>();
  invalidMeetingMessage$ = this.invalidMeetingMessage.asObservable();

  meeting$ = this.store.select(getMeeting);
  meetingLoaded$ = this.store.select(getMeetingLoaded);

  // == SIDE EFFECTS ======================================

  onMeeting$ = this.meeting$.pipe(
    tap(meeting => {
      if (!meeting || !meeting.id) {
        if (this.meetingCode.value) {
          this.invalidMeetingMessage.next(`Could not find meeting code ${this.meetingCode.value}`);
        } else {
          this.invalidMeetingMessage.next(`Could not find any meetings for email ${this.email.value}`);
        }
      } else {
        this.store.dispatch(MeetingAttendeesActions.goToStep({ 
          step: MeetingCheckInSteps.attendeeCheckIn 
        }))
      }
    })
  );  

  // == SUBSCRIPTIONS =====================================

  subscription = merge(
    this.onMeeting$
  ).subscribe();

  // == LIFECYCLE =========================================

  constructor(private store: Store<MeetingAttendeesPartialState>,
              private router: Router) { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // == HELPERS ===========================================

  findMeeting() {
    this.store.dispatch(MeetingAttendeesActions.loadMeeting({ 
      email: this.email.value,
      meetingId: this.meetingCode.value
    }));
  }
  
  navigateToGuestCheckIn() {
    this.store.dispatch(MeetingAttendeesActions.clearStore());
    this.router.navigate(['/check-in/guest']);
  }
}
